import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { getWineClubs, selectWineClubs } from "store/vino/wineClubsSlice";
import WineClubsList from "./WineClubsList";

const Root = styled("div")(({ theme }) => ({
	"& .SubscriptionPage-header": {
		height: 600,
		background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
		color: theme.palette.primary.contrastText,
	},
	"& .SubscriptionPage-badge": {
		backgroundColor: theme.palette.error.main,
		color: theme.palette.getContrastText(theme.palette.error.main),
	},
}));

const WineClubs = () => {
	const dispatch = useDispatch();
	const wineClubs = useSelector(selectWineClubs);

	useEffect(() => {
		dispatch(getWineClubs());
	}, [dispatch]);

	return (
		<Root className="w-full">
			<div className="">
				<div className="w-full max-w-2xl mx-auto">
					<WineClubsList wineClubs={wineClubs} />
				</div>
			</div>
		</Root>
	);
};

export default WineClubs;
